import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import {
  AccountsService,
  CreateReceiptCommand
} from '@api-accounting-client';
import  { SalesInvoicesService } from '@api-reports-client';

import { AppNavigationService } from '../../../shared/services/app';
import {
  DialogExtendedService,
  NotificationsExtendedService
} from '../../../shared/services';
import { IssueReceiptFormBaseComponent } from '../issueReceiptFormBaseComponent';

@Component({
    selector: 'app-issue-receipts-add',
    templateUrl: './issue-receipts-add.component.html',
    styleUrls: ['./issue-receipts-add.component.scss'],
    standalone: false
})
export class IssueReceiptsAddComponent
  extends IssueReceiptFormBaseComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  constructor(
    protected appNavigationService: AppNavigationService,
    protected formBuilder: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
    protected salesInvoicesService: SalesInvoicesService,
    protected accountsService: AccountsService,
    protected dialogExtendedService: DialogExtendedService,
    protected notificationsExtendedService: NotificationsExtendedService
  ) {
    super(
      appNavigationService,
      formBuilder,
      accountsService,
      salesInvoicesService,
      dialogExtendedService,
      notificationsExtendedService
    );
  }

  async ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  onRun() {
    const amount = this.form?.value?.baseAmount || 0;
    this.invoicesGrid.allAllocate(amount);
  }

  canRun(): boolean {
    const amount = this.form?.value?.baseAmount || 0;
    const hasGridData = this.invoicesGrid?.gridData?.length > 0;
    return amount > 0 && hasGridData;
  }

  onDataSubmit(command: CreateReceiptCommand) {
    return this.receiptsService.receiptsPost(command);
  }

  isAmountInvalid(field: string) {
    const control = this.form.controls[field];
    const allocatedTotal =
      field === 'baseAmount'
        ? this.invoicesGrid?.gridData?.reduce((sum, row) => sum + (Number(row.baseAmount) || 0), 0)
        : field === 'baseAmount2'
          ? this.invoicesGrid?.gridData?.reduce((sum, row) => sum + (Number(row.baseAmount2) || 0), 0)
          : this.invoicesGrid?.gridData?.reduce((sum, row) => sum + (Number(row.amount) || 0), 0);
    // Check if amount is 0 or less than sum of payments
    return (
      (Number(control.value) <= 0 ||
        Number(control.value) < allocatedTotal) &&
      !control.pristine
    );
  }
  
  isAmountRequired(field: string) {
    return this.form.controls[field]?.errors?.required;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
